<div class="c-slat u-mb1">
  @for (_ of [].constructor(3); track _; let last = $last) {
    <mvw-loading-vacature-detail/>
    @if (!last) {
      <div class="c-slat__divider"></div>
    }
  }
</div>
